// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"4112":"de809ca6","4688":"1f6e1b97"}[chunkId] + ".css";
};